// react
import { useState } from 'react';

// internationalization
import { useTranslation } from 'react-i18next';

// material ui icons
import BoltIcon from '@mui/icons-material/Bolt';
import FilterListIcon from '@mui/icons-material/FilterList';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import PercentIcon from '@mui/icons-material/Percent';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';

// material ui
import { Box, Grow, IconButton, InputAdornment, Tooltip } from '@mui/material';
import {
  GridToolbar,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid-premium';

const StandardAnalysisToolbar = ({ setShowPercentage, showPercentage }) => {
  const { t } = useTranslation('common');
  const [showToolbar, setShowToolbar] = useState(false);

  return (
    <GridToolbarContainer
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 1,
        background: 'inherit',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <GridToolbarQuickFilter
          size="small"
          sx={{
            '& .MuiInputBase-root': {
              backgroundColor: (theme) => theme.palette.background.paper,
              borderRadius: 2,
            },
            '& .MuiFilledInput-root': {
              borderRadius: '5px',
            },
            '& .MuiInput-underline:before, & .MuiInput-underline:after': {
              display: 'none',
            },
            '& .MuiInputLabel-root': {
              color: 'gray',
            },
          }}
          variant="outlined"
          InputProps={{
            placeholder: 'Søg...',
            startAdornment: (
              <InputAdornment position="start">
                <SearchRoundedIcon sx={{ color: 'gray' }} />
              </InputAdornment>
            ),
          }}
        />
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Grow in={showToolbar}>
          <Box>
            <GridToolbar />
          </Box>
        </Grow>

        <Tooltip
          title={
            showToolbar
              ? t('tooltips.hideSettings')
              : t('tooltips.showSettings')
          }
          placement="top"
        >
          <IconButton
            onClick={() => setShowToolbar(!showToolbar)}
            sx={{ borderRadius: 1 }}
          >
            {showToolbar ? <FilterListOffIcon /> : <FilterListIcon />}
          </IconButton>
        </Tooltip>
        <Tooltip
          title={
            showPercentage
              ? t('energyxplorer:tooltips.showConsumption')
              : t('energyxplorer:tooltips.showPercentage')
          }
          placement="top"
        >
          <IconButton
            onClick={() => setShowPercentage(!showPercentage)}
            sx={{ borderRadius: 1 }}
          >
            {showPercentage ? <BoltIcon /> : <PercentIcon />}
          </IconButton>
        </Tooltip>
      </Box>
    </GridToolbarContainer>
  );
};

export default StandardAnalysisToolbar;
